import makeStyles from '@mui/styles/makeStyles';
import CircularProgress from '@mui/material/CircularProgress';
import { useIntl, FormattedMessage } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';
import { fromOrder } from '../../../store/rootReducer';
import { Feature, PlanInterval } from '../../../models';
import { getPlanId } from '../utils';

const useStyles = makeStyles(({
  container: {
    width: '100%',
  },
  namePriceContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    position: 'relative',
  },
  name: {
    fontSize: 14,
    fontWeight: 700,
    color: '#233145',
    width: '70%',
    marginBottom: 0,
  },
  sumPrice: {
    fontSize: 14,
    fontWeight: 700,
    color: '#22283c',
    top: 0,
    right: 0,
    position: 'absolute',
  },
  circleProgress: {
    top: 12,
    right: 0,
    position: 'absolute',
  },
  unitPriceBillingCycleContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    width: '100%',
  },
  unitPrice: {
    fontSize: 12,
    fontWeight: 500,
    color: '#727993',
  },
  billingCycle: {
    fontSize: 12,
    fontWeight: 500,
    color: '#4d5369',
    bottom: 0,
    right: 0,
    position: 'absolute',
  },
  line: {
    border: 'none',
    borderTop: '1px dashed #d6dae4',
  },
}));

interface OrderItemProps {
  chosenInterval: any,
  feature: Feature,
  chosenQuota: number,
  unitPrice: number,
  planName: string,
  quotaType: string,
}

const OrderItem = (props: OrderItemProps) => {
  const {
    chosenInterval,
    feature,
    chosenQuota,
    unitPrice,
    planName,
    quotaType,
  } = props;

  const classes = useStyles();
  const intl = useIntl();

  const loading = useSelector(fromOrder.selectPreviewLoading);

  const planId = (chosenInterval: PlanInterval): string => getPlanId(
    feature,
    chosenInterval,
  );

  const preview = useSelector(fromOrder
    .selectProductPreviewByProductId(planId(chosenInterval)), shallowEqual);

  return (
    <div id="order-item">
      <div className={classes.container}>
        <div className={classes.namePriceContainer}>
          <p className={classes.name}>
            <FormattedMessage id={planName} />
          </p>
          {
            loading
              ? <CircularProgress className={classes.circleProgress} size={20} />
              : <p className={classes.sumPrice}>{`$${intl.formatNumber(preview?.subTotal || 0)}`}</p>
          }
        </div>
        <div className={classes.unitPriceBillingCycleContainer}>
          <p className={classes.unitPrice}>
            {feature === Feature.TESTOPS_PLATFORM || feature === Feature.VISUAL_TESTING_PRO ? `${chosenQuota} ` : `$${intl.formatNumber(unitPrice)} x ${chosenQuota} `}
            <FormattedMessage id={quotaType} />
          </p>
          <p className={classes.billingCycle}>
            {'Bill '}
            {chosenInterval === 'YEAR' ? <FormattedMessage id="subscriptions.testops_platform.annual" /> : <FormattedMessage id="subscriptions.testops_platform.monthly" />}
          </p>
        </div>
      </div>
      <div className={classes.line} />
    </div>
  );
};

export default OrderItem;
